<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosCustomerChangeTask"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="customerName" :label="t('operate.mzmxr7')">
              <CustomerAreaCascader appId="cos_ofbu" type="search" v-model:ids="queryForm.manageAreaList" />
            </dc-form-item>
            <dc-form-item name="arkCode" :label="t('operate.y20bdt')">
              <user-select v-model:value="queryForm.seller" />
            </dc-form-item>
            <dc-form-item name="arkCode" :label="t('common.createByName')">
              <user-select v-model:value="queryForm.createBy" />
            </dc-form-item>
            <dc-form-item name="arkCode" :label="t('common.createTime')">
              <cos-range-picker v-model:startTime="queryForm.startTime" v-model:endTime="queryForm.endTime" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'manageAreaId'">
            <CustomerAreaCascaderText appId="cos_ofbu" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'msg'">
            <p>{{ t('operate.rn82s1') }}：{{ record.clueNum || 0 }}</p>
            <p>{{ t('operate.px4c2i') }}：{{ record.customerContractNum || 0 }}</p>
            <!-- <p>{{ t('operate.2cy4dq') }}：{{ record.customerDealAmount || 0 }}</p> -->
            <p>{{ t('operate.pphnkg') }}：{{ record.customerDealNum || 0 }}</p>
            <p>{{ t('operate.4n7op9') }}：{{ record.customerPotentialNum || 0 }}</p>
          </template>
          <template v-if="column.dataIndex === 'monthDate'">
            <p>{{ text ? dayjs(text).format('YYYY/MM') : '--' }}</p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="addEdit(record)" v-permission="'ofbu_cuschangetask_edit_btn'">{{
                t('btn.edit')
              }}</a-button>
              <a-button type="link" @click="deleteRow(record)" v-permission="'ofbu_cuschangetask_delete_btn'">{{
                t('btn.del')
              }}</a-button>
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit()" v-permission="'ofbu_cuschangetask_add_btn'">{{
            t('btn.add')
          }}</a-button>
          <ImportBtn
            action="/ofbu/api/customerConversionTask/import"
            templateUrl="/ofbu/api/customerConversionTask/template/download"
            @success="success('search')"
            v-permission="'ofbu_cuschangetask_import_btn'"
            >{{ t('btn.import') }}</ImportBtn
          >
          <!-- <a-button type="primary" @click="handleTempleExport()">导入模板</a-button> -->
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import dayjs from 'dayjs'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import {
  customerConversionTaskList,
  customerConversionTaskDelete
  // customerConversionTaskImportTemple
} from '@/api/overseasSales/businessRuleSetting'
import ImportBtn from '@/components/ImportBtn'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import { useI18n } from 'vue-i18n'
import { DcMessage } from '@dc-platform/dc-components'
import { BigScoreBakcData } from '@/typings/api/overseasSales'
export default { name: 'DcCosOFbuCustomerChangeTask' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const editModalRef = ref()

const tableRef = ref()
const queryForm = reactive({
  startTime: '',
  endTime: ''
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await customerConversionTaskList({ ...params, appId: 'cos_ofbu' })
  callBack(res)
}
const columns = computed(() => [
  { title: t('operate.mzmxr7'), dataIndex: 'manageAreaId' },
  { title: t('operate.y20bdt'), dataIndex: 'sellerName' },
  { title: t('operate.7so5mb'), dataIndex: 'msg', minWidth: 270 },
  { title: t('operate.tnp6po'), dataIndex: 'monthDate' },
  { title: t('common.createByName'), dataIndex: 'createByName' },
  { title: t('common.createTime'), dataIndex: 'createTime', minWidth: 110 },
  {
    title: t('common.action'),
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: BigScoreBakcData) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: { seller: string; id: any }) => {
  Modal.delete({
    onOk() {
      customerConversionTaskDelete({ id: row.id }).then(() => {
        DcMessage.success(t('operate.6k2ifb'))
        tableRef.value?.delFetch()
      })
    }
  })
}
const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// const handleTempleExport = async () => {
//   try {
//     const res = await customerConversionTaskImportTemple()
//   } catch (error) {
//     console.log('error: ', error)
//   }
// }
</script>

<style scoped></style>
